import { CodeBlock, dracula } from 'react-code-blocks';
import styles from './style.module.scss';

interface Props {
    checked: boolean;
    setChecked: (checked: boolean) => void;
    text?: string;
    disabled?: boolean;
    className?: string;
    radioClassName?: string;
};

function RadioButton(props: Props) {
    const {
        checked,
        radioClassName,
        className,
        disabled,
        setChecked,
        text,
    } = props;

    const click = () => {
        if (disabled) return;
        setChecked(!checked);
    };

    return (
        <div className={`${styles.wrapper} ${className || ''}`} onClick={click}>
            <div
                className={`${styles.radio} ${radioClassName || ''}`}
                data-radio-checked={checked}
            >
                <span className={styles.radio_disk}></span>
            </div>
            {text && text.includes('```') ? <div className={styles.code_block}>
                <CodeBlock
                    text={text.split('```')[1]}
                    language={'python'}
                    showLineNumbers={true}
                    theme={dracula}
                />
            </div> :
                (text && <span className={styles.text}>{text.split(/(\`.*?\`)/g).map(i => {
                    if (i.startsWith('`')) {
                        return <code className={styles.code}>{i.slice(1, i.length - 1)}</code>
                    } else {
                        return <span>{i}</span>
                    }
                })}</span>)}
        </div>
    );
};

export default RadioButton;
